import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=0c5a9711&scoped=true"
import script from "./FaqPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a9711",
  null
  
)

export default component.exports